import { IconTag } from "@msuite/ui/tag";
import { moment } from "@msuite/utils/date";
import { getHoursString } from "@msuite/utils/numbers";
import { calculateBookings } from "@msuite/utils/partnerships";
import type { BookingsReviewListItem } from "@msuite/utils/types";

/** Props Interface */
interface DashboardPartnerBookingReviewItemProps {
	booking: BookingsReviewListItem;
}

/**
 * One record waiting on the host, laid out like a row of the partner's tile: the day, the site,
 * the hours submitted and the partner crew that booked them.
 */
export function DashboardPartnerBookingReviewItem({
	booking,
}: DashboardPartnerBookingReviewItemProps) {
	/** Computed */
	const { submittedHours } = calculateBookings(booking.ticketAssignmentReferenceBookings, null);

	/** Render */
	return (
		<>
			<div className="v-stack gap-0 items-start text-left min-w-0">
				<p className="truncate max-w-full">{moment(booking.date).dateFormat()}</p>
				<p className="truncate max-w-full">
					<span className="font-semibold">{booking.project.name}</span>
					{booking.project.number ? (
						<span className="font-normal">{` (${booking.project.number})`}</span>
					) : null}
				</p>
			</div>
			<div className="flex-1" />
			<div className="v-stack gap-0 items-end shrink-0 pl-3">
				<IconTag
					iconName="Clock"
					variant="plain"
				>
					{getHoursString(submittedHours)}
				</IconTag>
				<p className="truncate max-w-full">
					{booking.organizationName} {booking.ranking}
				</p>
			</div>
		</>
	);
}
